export const plans = {
  title: "Choisissez votre formule",
  subtitle: "Prix par unité et par mois, avec remises sur volume. Vous pouvez combiner plusieurs types d'hébergement dans une même commande.",
  typeLabel: "Type d'hébergement",
  types: {
    apartamento: "Appartements",
    hotel: "Hôtel",
    camping: "Camping",
    villa: "Villas",
  },
  units: {
    apartamento: "appartement | appartements",
    hotel: "chambre | chambres",
    camping: "emplacement | emplacements",
    villa: "villa | villas",
  },
  decrease: "Retirer une unité",
  increase: "Ajouter une unité",
  billing: {
    label: "Facturation",
    monthly: "Mensuel",
    annual: "Annuel",
    annualSave: "−20%",
  },
  perUnit: "/mois par unité",
  totalLine: "{qty} {units} · {total}/mois au total",
  billedAnnually: "facturé annuellement",
  add: "Ajouter à la commande",
  isNew: "Nouveau",
  pro: {
    badge: "Le plus populaire",
    tagline: "Toute la plateforme : IA, canaux, encaissements et revenus.",
    f1: "Check-in en ligne et fiches de police envoyées automatiquement aux autorités",
    f2: "Réception IA 24/7 par WhatsApp : accueille, répond aux questions et automatise",
    f3: "Boîte de réception unifiée (WhatsApp + Booking, Airbnb et Expedia), traduction et transfert à un humain",
    f4: "Facturation électronique conforme",
    f5: "Channel Manager +100 OTA, calendrier unifié et gestion des tarifs (zéro surréservation)",
    f6: "Réservations directes avec votre propre site web, sans commissions",
    f7: "Serrures connectées avec codes d'accès automatiques",
    f8: "Extras et upselling, prolongation du séjour et promotions",
    f9: "Encaissements et paiements avec acomptes",
    f10: "Ménage et équipe, avec rôles et accès",
    f11: "Multipropriété, analytics et rapports par propriétaire",
  },
  suite: {
    badge: "Tout inclus",
    tagline: "La formule la plus complète : réception téléphonique avec IA, votre propre site web et tarifs dynamiques.",
    lead: "Tout ce qui est inclus dans Pro, et en plus :",
    s1: "Numéro dédié pour WhatsApp et les appels",
    s2: "Réception IA téléphonique : répond au téléphone 24/7 dans la langue du voyageur",
    s3: "Appels entrants : 40 min/mois inclus",
    s4: "WebBuilder : votre site web complet",
    s5: "Tarifs dynamiques : ajustement automatique des prix",
    s6: "Plusieurs entités de facturation à associer à chaque hébergement",
  },
  cart: {
    title: "Votre commande",
    empty: "Choisissez le type d'hébergement et le nombre d'unités, puis ajoutez une formule.",
    plan: "Formule {plan}",
    remove: "Retirer",
    monthlyTotal: "Total par mois",
    annualTotal: "Facturé par an : {total}",
    planSwitched: "Une commande n'a qu'une formule : tout passe en {plan}.",
    welcomeTitle: "Remise de parrainage appliquée",
    welcomeMonthly: "{percent} % de réduction sur vos {months} premiers mois : {total}/mois",
    welcomeAnnual: "Vous économisez {amount} sur votre première facture annuelle",
    pay: "Continuer vers le paiement",
    paying: "Ouverture du paiement…",
    taxes: "Taxes non incluses. Stripe vous demandera vos informations de facturation.",
    error: "Impossible d'ouvrir le paiement. Veuillez réessayer.",
  },
  payment: {
    success: "Paiement reçu. Votre formule sera active dans quelques secondes.",
    failed: "Le paiement n'a pas abouti. Vous pouvez réessayer quand vous voulez.",
    active: "C'est prêt ! Votre formule est active.",
  },
  active: {
    includes: "Ce que comprend votre formule",
    discount: "Remise de parrainage : {percent} % jusqu'au {date}",
    discountAnnual: "Remise de parrainage appliquée à votre première facture",
    referralCredit: "Vous avez {amount} de crédit pour avoir invité d'autres hôtes : il sera déduit de votre prochaine facture.",
  },
};
